/** Client-side pre-check only — the backend (SkillService.ALLOWED_SKILL_URL_HOSTS) is the real
 *  trust boundary and must be kept in sync, along with the worker's own allowlist
 *  (packages/worker/src/skillFetch.ts ALLOWED_HOSTS). */
const ALLOWED_HOSTS = new Set(['git.autodesk.com']);
export function isValidSkillUrl(value) {
    const trimmed = value.trim();
    if (!trimmed)
        return false;
    try {
        const parsed = new URL(trimmed);
        return ALLOWED_HOSTS.has(parsed.hostname);
    }
    catch {
        return false;
    }
}
